import React from "react";
import { CardAnim2 } from "../ItemsUI";

const AUTHOR_IMG = "/mnt/data/Screenshot 2025-11-15 210257.png";

export default function HeroCard18() {
  return (
    <>
      <section className="pub-cm18-hero">
        {/* Dark overlays */}
        <div className="pub-cm18-overlay"></div>
        <div className="pub-cm18-gradient"></div>

        {/* Floating particles */}
        <div className="pub-cm18-particles">
          {Array.from({ length: 40 }).map((_, i) => (
            <span key={i} style={{ "--i": i }}></span>
          ))}
        </div>

        <div className="pub-cm18-container">

          {/* LEFT */}
          <div className="pub-cm18-left">
            <h5 className="pub-cm18-mini-title">PUBLISHING HOUSE</h5>

            <h1 className="pub-cm18-title">
              THE NEW NOVEL FROM <br />
              <span>JOHN VERMA</span>
            </h1>

            <p className="pub-cm18-desc">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
              tempor incididunt ut labore et dolore magna aliqua.
            </p>

            <div className="pub-cm18-cta-row">
              <button className="pub-cm18-btn-primary pulse-button">READ MORE</button>
              <button className="pub-cm18-btn-secondary">CONTACT US</button>
            </div>
          </div>

          {/* RIGHT */}
          <div className="pub-cm18-right">
              <CardAnim2 id={"cmHC18"} mode ={"dark"} colors={{c1:"rgba(54, 128, 255, 1)",c2:"rgba(31, 29, 29, 1)"}} />
                       </div>
        </div>

        {/* Dots (decorative only) */}
        <div className="pub-cm18-dots">
          <span className="pub-cm18-dot active"></span>
          <span className="pub-cm18-dot"></span>
          <span className="pub-cm18-dot"></span>
        </div>
      </section>

      <style>{`
/* --------------------- HERO BASE --------------------- */
.pub-cm18-hero {
  position: relative;
  min-height: 70vh;
  background: #0b0b0d;
 
  padding: 50px 6%;
  display: flex;
  align-items: center;
}

/* Soft book texture overlay */
.pub-cm18-overlay {
  position: absolute;
  inset: 0;
  background: url("https://www.transparenttextures.com/patterns/black-linen.png");
  opacity: 0.15;
  z-index: 1;
}

/* Dark vignette gradient */
.pub-cm18-gradient {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 40%, rgba(0,0,0,0.4), rgba(0,0,0,0.95)),
              linear-gradient(to right, rgba(0,0,0,0.8), transparent);
  z-index: 2;
}

/* ---------------- FLOATING PARTICLES ---------------- */
.pub-cm18-particles {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.pub-cm18-particles span {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255,255,255,0.35);
  border-radius: 50%;
  animation: floatUp 12s linear infinite;
  left: calc(var(--i) * 3%);
  top: 110%;
}
@keyframes floatUp {
  0% { opacity: 0; transform: translateY(0) scale(0.5); }
  40% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-120vh) scale(1); }
}

/* ------------------ LAYOUT ------------------ */
.pub-cm18-container {
  position: relative;
  z-index: 4;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1350px;
  align-items: center;
}

/* ---------------- LEFT ---------------- */
.pub-cm18-left {
  max-width: 440px;
}

.pub-cm18-mini-title {
  color: #c3c4c6;
  font-size: 1rem;
  margin-bottom: 14px;
  letter-spacing: 1px;
}

.pub-cm18-title {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  color: #fff;
}
.pub-cm18-title span {
  color: rgba(54, 128, 255, 1);
}

.pub-cm18-desc {
  margin-top: 16px;
  color: #d1d1d1;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 26px;
}

/* CTA Buttons */
.pub-cm18-cta-row {
  display: flex;
  gap: 20px;
}

.pub-cm18-btn-primary {
  background: #3c6dff;
  border: none;
  padding: 14px 32px;
  font-size: 1rem;
  border-radius: 8px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: 0.3s;
}

/* PULSE EFFECT */
.pulse-button {
  animation: pulseGlow 2s infinite;
}

@keyframes pulseGlow {
  0% { box-shadow: 0 0 0 0 rgba(60,109,255,0.6); }
  70% { box-shadow: 0 0 20px 14px rgba(60,109,255,0); }
  100% { box-shadow: 0 0 0 0 rgba(60,109,255,0); }
}

.pub-cm18-btn-secondary {
  border: 2px solid #ffffffa8;
  background: transparent;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 1rem;
  color: #fff;
  cursor: pointer;
}

/* ---------------- RIGHT ---------------- */
.pub-cm18-right {
  position: relative;
  display: flex;left:-160px;top:150px;
  justify-content: flex-start;transform:scale(1.1);
}

.pub-cm18-author-img {
  width: 420px;
  border-radius: 4px;
  object-fit: contain;
  position: relative;
  z-index: 4;
  filter: brightness(0.92);
}

/* ---------------- DOTS ---------------- */
.pub-cm18-dots {
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pub-cm18-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #ffffff80;
  cursor: pointer;
}
.pub-cm18-dot.active {
  background: #3c6dff;
  border-color: #3c6dff;
}

/* Responsive */
@media (max-width: 980px) {
  .pub-cm18-container { flex-direction: column-reverse; text-align: center; gap: 40px; }
  .pub-cm18-right { justify-content: center; }
  .pub-cm18-dots { right: 20px; }
  
}
      `}</style>
    </>
  );
}
